import { io } from 'socket.io-client';
import { ref } from 'vue';

export default function useWebSocket(token) {
  const socket = ref(null);
  const isConnected = ref(false);
  const error = ref(null);

  function init() {
    console.log('Initializing WebSocket connection...', import.meta.env.VITE_OMIND_WS_SERVICE);
    socket.value = io(import.meta.env.VITE_OMIND_WS_SERVICE || '', {
      path: '/socket.io',
      query: {
        token,
      },
      transports: ['websocket', 'polling'],
      reconnection: true,
      reconnectionAttempts: Infinity,
      reconnectionDelay: 1000,
    });

    socket.value.on('connect', () => {
      isConnected.value = true;
      error.value = null;
      console.log('Connected to WebSocket server');
    });
    socket.value.on('disconnect', (reason) => {
      isConnected.value = false;
      error.value = reason;
      console.log('Disconnected from WebSocket server:', reason);
    });
    socket.value.on('connect_error', (err) => {
      isConnected.value = false;
      error.value = err;
      console.log('Connection error:', err);
    });
    socket.value.on('reconnect_attempt', (attemptNumber) => {
      console.log('Reconnecting attempt:', attemptNumber);
    });
    socket.value.on('reconnect', (attemptNumber) => {
      console.log('Reconnected successfully on attempt:', attemptNumber);
    });
  }

  init();

  return { socket, isConnected, error };
}
